<script>
    import { push, replace } from "svelte-spa-router";
    import GeneralHeaderBar from "../../../common/header/GeneralHeaderBar.svelte";
    import ImageGrid from "../components/ImageGrid.svelte";
    import NextSaalButton from "../components/NextSaalButton.svelte";
    import PreviousSaalButton from "../components/PreviousSaalButton.svelte";
    import { _ } from "svelte-i18n";
    import { getEntities, getEntity } from "../../../api-client";
    import LoadingSquare from "../../../common/LoadingSquare.svelte";

    export let params = {};
    $: if (params.id) {
        window.scrollTo(0, 0);
    }
    $: saalheftId = params.saalheftId;
    $: saaltextId = params.id;

    $: saalheft = getEntity("saalheft", saalheftId);
    $: saaltext = getEntity("saaltext", saaltextId);
    $: saaltexte = getEntities("saaltext");

    function findSaaltextNumber(saaltexte) {
        return findSaaltextIndex(saaltexte) + 1;
    }

    function findSaaltextIndex(saaltexte) {
        return saaltexte.findIndex((saaltext) => saaltext.id === saaltextId);
    }
</script>

{#await saaltext}
    <LoadingSquare />
{:then saaltext}
    <GeneralHeaderBar title={saaltext.name} flexHeader onSite>
        <div
            style="cursor: pointer"
            slot="post-title"
            on:click={() => replace(`/saalheft/${saalheftId}`)}
        >
            <img src="./images/icons/close.svg" alt={$_("close")} />
        </div>
    </GeneralHeaderBar>

    <div class="content">
        <div class="header">
            <div class="headline-m headline">{saaltext.name}</div>
            {#await saaltexte then saaltexte}
                <div class="headline-m subheadline">
                    {$_("hall")}
                    {findSaaltextNumber(saaltexte)}
                </div>
            {/await}
        </div>

        <div class="sections">
            {#each saaltext.sections ?? [] as section}
                {#if section.type === "html"}
                    <div class="text-l text-section">
                        {@html section.content}
                    </div>
                {:else if section.type === "images"}
                    <div class="spacer" />
                    <ImageGrid images={section.images} />
                    <div class="spacer" />
                {/if}
            {/each}
        </div>

        <!-- Link to next Saaltext -->
        <div class="footer">
            {#await saaltext then saaltext}
                {#await saaltexte then saaltexte}
                    {#if findSaaltextNumber(saaltexte) < saaltexte.length}
                        {#await getEntity("saaltext", saaltexte[findSaaltextIndex(saaltexte) + 1].id) then nextSaaltext}
                            <div class="divider-h divider" />
                            <NextSaalButton
                                on:click={() =>
                                    replace(
                                        `/saaltext/${saalheftId}/${nextSaaltext.id}`
                                    )}
                            />
                            <div class="headline-m next-saal-title headline">
                                {nextSaaltext.name}
                            </div>
                            <div class="headline-m subheadline">
                                {$_("hall")}
                                {findSaaltextNumber(saaltexte) + 1}
                            </div>
                        {/await}
                    {/if}
                {/await}

                {#await saaltexte then saaltexte}
                    <div class="divider-h divider" />
                    {#await saaltext then saaltext}
                        <PreviousSaalButton
                            previousSaalNumber={saaltexte.findIndex(
                                (s) => s.id === saaltext.id
                            )}
                            on:previousSaal={() =>
                                replace(
                                    `/saaltext/${saalheftId}/${
                                        saaltexte[
                                            saaltexte.findIndex(
                                                (s) => s.id === saaltext.id
                                            ) - 1
                                        ].id
                                    }`
                                )}
                            on:lastSaal={() =>
                                replace(
                                    `/saaltext/${saalheftId}/${
                                        saaltexte[saaltexte.length - 1].id
                                    }`
                                )}
                        />
                    {:catch}
                        <div class="error">
                            <span class="text-l" style="font-size: 24px;">
                                {$_("entity_load_error")}
                            </span>
                        </div>
                    {/await}
                {:catch}
                    <div class="error">
                        <span class="text-l" style="font-size: 24px;">
                            {$_("entity_load_error")}
                        </span>
                    </div>
                {/await}

                <div class="divider-h divider" />
            {:catch}
                <div class="error">
                    <span class="text-l" style="font-size: 24px;">
                        {$_("entity_load_error")}
                    </span>
                </div>
            {/await}
        </div>
    </div>
{:catch}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}

<style>
    .content {
        padding: 0 16px 32px 16px;
        display: flex;
        flex-direction: column;
    }

    .header {
        margin: 32px 0;
        max-width: 655px;
        width: 100%;
        align-self: center;
    }

    .subheadline {
        color: var(--black-40);
    }

    .spacer {
        height: 32px;
    }

    .text-section {
        margin: 8px 0;
        max-width: 655px;
        align-self: center;
    }

    .sections {
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;
    }

    .divider {
        margin: 8px 0;
    }

    .next-saal-title {
        padding-right: 64px;
        word-break: normal;
        max-lines: 3;
    }

    @media only screen and (min-width: 1440px) {
        .header {
            margin: 128px 0 32px 0;
        }

        .text-section {
            margin: 112px 0;
            font-weight: 400;
            font-size: 18px;
            line-height: 112%;
            letter-spacing: -0.02em;
        }

        .headline {
            font-weight: 700;
            font-size: 48px;
            line-height: 95%;
            letter-spacing: -0.04em;
        }

        .subheadline {
            font-weight: 700;
            font-size: 48px;
            line-height: 95%;
            letter-spacing: -0.04em;
        }

        .footer {
            margin: 0 32px;
        }
    }
</style>
